<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div style="text-align:center;margin-bottom:20px;">
      <p>{{$t('componentConditionManage.confirmDeleteCondition')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="handleConfirm">{{$t('common.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteReportCustomComponentCondition } from '@/api/dev/componentConditionApi'

export default {
  name: 'DeleteComponentCondition',
  data() {
    return {
      dialogVisible: false,
      conditionData: {}
    }
  },
  methods: {
    open(params) {
      this.conditionData = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.conditionData = {}
    },
    async handleConfirm() {
      try {
        await deleteReportCustomComponentCondition(this.conditionData)
        this.$message.success(this.$t('common.submitSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>